export default __webpack_public_path__ + "static/media/kyc-light.1b351f20.svg";